import { render, staticRenderFns } from "./PersonalityMagneticSection.vue?vue&type=template&id=05313ff4"
import script from "./PersonalityMagneticSection.vue?vue&type=script&lang=ts"
export * from "./PersonalityMagneticSection.vue?vue&type=script&lang=ts"
import style0 from "./PersonalityMagneticSection.vue?vue&type=style&index=0&id=05313ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports